module.exports = function(video) {
	'use strict'
	video.directive('videoTagEditDir',videoTagEditDir);
	videoTagEditDir.$inject=[];
	function videoTagEditDir() {
		return {
			template: require('./partial/video-tag-edit.html'),
			controller:'videoTagEditController',
			controllerAs:'vmvte',
			link: function(scope, element, attrs, ctrl) {
				    
			}

		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/videoModule/video-tag-edit/js/directive/videoTagEditDirective.js
// module id = 654
// module chunks = 0